let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6EQss"), load("gfSAM"), load("hhss7"), load("aoU9B")]).then(() => parcelRequire('a6OFr'));